import React from 'react';
import { NavLink } from 'react-router-dom';

import { Roles } from 'core/components';
import { hasRole } from 'core/utils';

export const AdminAside = ({ arrayRoles, closeAdminMenu }) => {
	const closeAdminMenuHandler = () => {
		closeAdminMenu();
	};

	return (
		<aside className="admin__aside">
			<Roles isView={hasRole(arrayRoles, ['ROLE_GET_LOG'])}>
				<div className="admin__menu-block">
					<span>
						<svg role="img">
							<use
								xlinkHref={
									process.env.PUBLIC_URL + '/img/sprite.svg#admin-settings'
								}
							/>
						</svg>
						Статистика
					</span>
					<ul>
						<li>
							<NavLink
								to="/admin/statistic"
								onClick={closeAdminMenu && closeAdminMenuHandler}
								children="Группы"
							/>
						</li>
						<li>
							<NavLink
								to="/admin/search-statistic"
								onClick={closeAdminMenu && closeAdminMenuHandler}
								children="Поиск"
							/>
						</li>
						<li>
							<NavLink
								to="/admin/request-statistic"
								onClick={closeAdminMenu && closeAdminMenuHandler}
								children="Заявки"
							/>
						</li>
						<li>
							<NavLink
								to="/admin/club-card-statistic"
								onClick={closeAdminMenu && closeAdminMenuHandler}
								children="Карта МаксиКлуб"
							/>
						</li>
						<li>
							<NavLink
								to="/admin/users-info"
								onClick={closeAdminMenu && closeAdminMenuHandler}
								children="Пользователи"
							/>
						</li>
					</ul>
				</div>
				<div className="admin__menu-block">
					<span>
						<svg role="img">
							<use
								xlinkHref={
									process.env.PUBLIC_URL + '/img/sprite.svg#admin-settings'
								}
							/>
						</svg>
						Логи
					</span>
					<ul>
						<Roles isView={hasRole(arrayRoles, 'ROLE_GET_LOG')}>
							<li>
								<NavLink
									to="/admin/logi"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Логи с портала
								</NavLink>
							</li>
						</Roles>
						<Roles isView={hasRole(arrayRoles, 'ROLE_GET_LOG')}>
							<li>
								<NavLink
									to="/admin/ts-logs"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Логи из JMS
								</NavLink>
							</li>
						</Roles>
					</ul>
				</div>
			</Roles>

			<Roles
				isView={hasRole(arrayRoles, [
					'ROLE_EDIT_USER_CLAIMS',
					'ROLE_UPDATE_COMPETENCES',
					'ROLE_UPDATE_STICKER',
					'ROLE_EMILIA',
				])}
			>
				<div className="admin__menu-block">
					<span>
						<svg role="img">
							<use
								xlinkHref={process.env.PUBLIC_URL + '/img/sprite.svg#admin-prize'}
							/>
						</svg>
						Контент
					</span>

					<ul>
						<Roles isView={hasRole(arrayRoles, 'ROLE_UPDATE_COMPETENCES')}>
							<li>
								<NavLink
									to="/admin/competences"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Компетенции
								</NavLink>
							</li>
						</Roles>

						<Roles isView={hasRole(arrayRoles, 'ROLE_POSTER')}>
							<li>
								<NavLink
									to="/admin/poster/birthday"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Постеры ДР
								</NavLink>
							</li>
						</Roles>

						<Roles isView={hasRole(arrayRoles, 'ROLE_POSTER')}>
							<li>
								<NavLink
									to="/admin/poster/career"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Постеры назначения
								</NavLink>
							</li>
						</Roles>

						<Roles isView={hasRole(arrayRoles, 'ROLE_UPDATE_STICKER')}>
							<li>
								<NavLink
									to="/admin/stickers"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Стикеры
								</NavLink>
							</li>
						</Roles>

						<Roles isView={hasRole(arrayRoles, ['ROLE_ADMINISTRATOR', 'ROLE_EMILIA'])}>
							<li>
								<NavLink
									to="/admin/emilia"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Образы и фразы Эмилии
								</NavLink>
							</li>
						</Roles>
					</ul>
				</div>
			</Roles>

			<div className="admin__menu-block">
				<Roles isView={hasRole(arrayRoles, 'ROLE_EDIT_USER_ROLE_GROUP')}>
					<div className="admin__menu-block">
						<span>
							<svg role="img">
								<use
									xlinkHref={process.env.PUBLIC_URL + '/img/sprite.svg#admin-pin'}
								/>
							</svg>
							Распределение прав
						</span>

						<ul>
							<li>
								<NavLink
									to="/admin/rights/ROLE_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Тех. администратор
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/MAIN_PAGE_CONTENT_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Главная страница
								</NavLink>
							</li>
							{/* <li>
								<NavLink
									to="/admin/rights/CHAT_BOT_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Администратор чат-бота
								</NavLink>
							</li> */}
							<li>
								<NavLink
									to="/admin/rights/CHAT_BOT_USER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Доступность чат-бота для пользователей
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/SURVEY_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Опросы
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/DOCTOR_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Запись к терапевту
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/PSYCHOLOGIST_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Запись к психологу
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/DEVELOPMENT_GOAL_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Администратор ЛТР
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_COURIER_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Заказ курьера
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_VACATION_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Отпуск сотрудник СКД
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_VACATION_EXECUTOR_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Отпуск главный СКД
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_QUIZ_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									QUIZ
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_MESSAGE_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Горячая линия
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Управление группами
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/SUPER_VIEWER_FOR_GROUP"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Контент закрытых групп
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/CONTACT_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Справочник
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/MAXI_CLUB_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									МаксиКлуб
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WALK_OF_FAME_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Доска почета
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/PERSONAL_DATA_ACCEPT_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Персональные данные
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/LOG_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Системные логи
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/CAREER_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Назначения
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/COMPETENCES_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Компетенции
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/STICKER_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Стикеры
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_EDIT_USER_CLAIMS"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Заявки групп подразделений
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/ACTIVITIES_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Мероприятия
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/LOAD_LARGE_FILES_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Большие файлы
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/VACANCY_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Вакансии
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WIKI_GLOSSARY"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Глоссарий
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WIKI_FAQ_CATEGORIES"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									FAQ
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/FAQ_QUESTIONS"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Вопросы FAQ
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WIKI_DOCUMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Нормативные документы
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WIKI_GUIDE_TOP_CATEGORY"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Гид по компании
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/WIKI_ROLE"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Роли пользователей
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/SECRETARY_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Секретари-подразделения
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/SERVICE_TECHNICAL_MESSAGE_IT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									ИТ-услуги
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/TRIP_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Командировки
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/PASS_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Пропуска
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/APPROVE_PASS"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Согласованты пропусков
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/STATEMENT_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Справки
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/EDUCATION_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Заявка на обучение
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/EDUCATION_NOTIFY"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Уведомления о заявках на обучение
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/BUSINESS_CARD_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Визитки
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/EMILIA_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Образы и фразы Эмилии
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/MENTORING_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Менторинг
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_CORP_VALUES_MANAGEMENT"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Корпоративные ценности
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_ACHIEVEMENTS_GALLERY_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Галерея достижений
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/GROUP_ACHIEVEMENTS_USERS_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Назначение достижений
								</NavLink>
							</li>
							<li>
								<NavLink
									to="/admin/rights/INVENTORY_MANAGER"
									onClick={closeAdminMenu && closeAdminMenuHandler}
								>
									Инвентарное имущество
								</NavLink>
							</li>
						</ul>
					</div>
				</Roles>

				<Roles
					isView={hasRole(arrayRoles, [
						'ROLE_EDIT_USER_ROLE_GROUP',
						'ROLE_GET_PERSONAL_DATA_ACCEPT',
						'ROLE_EDIT_USER_CLAIMS',
						'ROLE_UPDATE_WIKI_ROLE',
						'ROLE_EDIT_SECRETARY',
					])}
				>
					<div className="admin__menu-block">
						<span>
							<svg role="img">
								<use
									xlinkHref={
										process.env.PUBLIC_URL + '/img/sprite.svg#admin-info'
									}
								/>
							</svg>
							Дополнительно
						</span>

						<ul>
							<Roles isView={hasRole(arrayRoles, 'ROLE_EDIT_USER_ROLE_GROUP')}>
								<li>
									<NavLink
										to="/admin/icons"
										onClick={closeAdminMenu && closeAdminMenuHandler}
									>
										Иконки
									</NavLink>
								</li>
							</Roles>

							<Roles isView={hasRole(arrayRoles, 'ROLE_GET_PERSONAL_DATA_ACCEPT')}>
								<li>
									<NavLink
										to="/admin/personal-accept"
										onClick={closeAdminMenu && closeAdminMenuHandler}
									>
										Согласия на обработку персональных данных
									</NavLink>
								</li>
							</Roles>

							<Roles isView={hasRole(arrayRoles, 'ROLE_UPDATE_WIKI_ROLE')}>
								<li>
									<NavLink
										to="/admin/roles-by-positions"
										onClick={closeAdminMenu && closeAdminMenuHandler}
									>
										Создание ролей пользователей
									</NavLink>
								</li>
							</Roles>

							<Roles isView={hasRole(arrayRoles, 'ROLE_EDIT_SECRETARY')}>
								<li>
									<NavLink
										to="/admin/secretary-to-department"
										onClick={closeAdminMenu && closeAdminMenuHandler}
									>
										Прикрепление секретарей к подразделениям
									</NavLink>
								</li>
							</Roles>

							{/* <Roles isView={hasRole(arrayRoles, 'ROLE_EDIT_USER_CLAIMS')}>
                                <li><NavLink to="/admin/news-moderation" onClick={closeAdminMenu && closeAdminMenuHandler}>Модерация новостей</NavLink></li>
                            </Roles> */}
						</ul>
					</div>
				</Roles>
			</div>
		</aside>
	);
};
